import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faProjectDiagram,
  faCalendarAlt,
  faGlobe,
  faUser,
  faUsers,
  faCommentDots,
  faStar,
  faMailBulk
} from '@fortawesome/free-solid-svg-icons';
const token = localStorage.getItem('token');

const CollaboratorDetails = () => {
  const { id } = useParams();
  const [collaborator, setCollaborator] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    const fetchCollaborator = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(`/collaborator/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCollaborator(res.data);
      } catch (err) {
        setError('Erreur lors du chargement du collaborator.');
      } finally {
        setLoading(false);
      }
    };

    fetchCollaborator();
  }, [id]);

  if (loading) return <p>Chargement du collaborator...</p>;
  if (error) return <p className="text-red-600">{error}</p>;
  if (!collaborator) return <p>Collaborator non trouvé.</p>;

  return (
    <div className="collaborator-detail-container">
      {/* Header Section */}
      <div className="collaborator-header">
        <div className="header-content">
          <div className="breadcrumb">
            <Link to="/admin/collaborators" className="back-button">
              <FontAwesomeIcon icon={faArrowLeft} />
              <span>Retour à la liste</span>
            </Link>
          </div>
          <h1 className="collaborator-title">
            <FontAwesomeIcon icon={faUser} className="title-icon" />
            {collaborator.name}
          </h1>
        </div>
      </div>

      <div className="project-content">
        {/* Collaborator Image */}
        {collaborator.photoUrl && (
          <div className="collaborator-image-section">
            <div className="image-container">
              <img
                src={`/${collaborator.photoUrl}`}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = '/defaults/defaultMemberImage.jpg';
                }}
                alt="Image du collaborator"
                className="project-image"
              />
            </div>
          </div>
        )}

        {/* Main Information */}
        <div className="collaborator-info-grid">
          <div className="info-card main-info">
            
            <div className="collaborator-details">
              <div className="detail-item">
                <FontAwesomeIcon icon={faMailBulk} className="detail-icon" />
                <div className="detail-content">
                  <span className="detail-label">E-mail</span>
                  <span className="detail-value">{collaborator.email}</span>
                </div>
              </div>

              {collaborator.jobTitle && (
                <div className="detail-item">
                  <FontAwesomeIcon icon={faGlobe} className="detail-icon" />
                  <div className="detail-content">
                    <span className="detail-label">Poste</span>
                    <a href={collaborator.jobTitle} target="_blank" rel="noopener noreferrer" className="website-link">
                      {collaborator.jobTitle}
                    </a>
                  </div>
                </div>
              )}
              {collaborator.positionJEI && (
                <div className="detail-item">
                  <FontAwesomeIcon icon={faGlobe} className="detail-icon" />
                  <div className="detail-content">
                    <span className="detail-label">positionJEI</span>
                    <a href={collaborator.positionJEI} target="_blank" rel="noopener noreferrer" className="website-link">
                      {collaborator.positionJEI}
                    </a>
                  </div>
                </div>
              )}
              {collaborator.contactLink && (
                <div className="detail-item">
                  <FontAwesomeIcon icon={faGlobe} className="detail-icon" />
                  <div className="detail-content">
                    <span className="detail-label">Contact</span>
                    <a href={collaborator.contactLink} target="_blank" rel="noopener noreferrer" className="website-link">
                      {collaborator.contactLink}
                    </a>
                  </div>
                </div>
              )}

              
            </div>
          </div>

          {/*Projets */}
          <div className="info-card collaborators-card">
            <h3 className="card-title">
              <FontAwesomeIcon icon={faProjectDiagram} />
              Projets
            </h3>
            {collaborator.projects.length > 0 ? (
              <div className="projects-list">
                {collaborator.projects.map((col) => (
                  <Link to={`/admin/projects/${col.id}`} className="back-button">
                    <div className="collaborator-avatar">
                      <FontAwesomeIcon icon={faProjectDiagram} />
                    </div>
                    <div className="collaborator-info">
                      <span className="collaborator-name">{col.projectName}</span>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <p className="no-data">Aucun projet assigné</p>
            )}
          </div>
        </div>

      </div>

      
    </div>
  );
};

export default CollaboratorDetails;
